import { useState } from 'react';
import { httpPost } from '../../../../../utils';

interface Props {
    onSuccessCallback: (data: string) => void;
    onErrorCallback: VoidFunction;
}

interface GenerateCertificateData {
    certificateType: { value: string; label: string };
    fields: {
        tenantID?: string;
    };
}

const generateCertificate = async (postData: GenerateCertificateData) => {
    const reqUrl = `/Settings/GenerateCertificate`;
    const { data }: { data: any } = await httpPost(reqUrl, postData);

    if (!data.publicKey) {
        throw new Error('Failed to generate certificate');
    }

    return data.publicKey;
};
const useGenerateCertificate = ({ onSuccessCallback, onErrorCallback }: Props) => {
    const [isLoading, setIsLoading] = useState(false);

    const generateCertificateMutation = async (postData: GenerateCertificateData) => {
        setIsLoading(true);
        try {
            const publicKey = await generateCertificate(postData);
            onSuccessCallback(publicKey);
        } catch (err) {
            onErrorCallback();
        } finally {
            setIsLoading(false);
        }
    };

    return { generateCertificateMutation, isLoading };
};

export default useGenerateCertificate;
